var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowsRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 112h211.8l-62.05 51.72c-6.781 5.656-7.703 15.75-2.047 22.53C326.9 190 331.4 192 336 192c3.609 0 7.234-1.219 10.23-3.719l96-80C445.9 105.3 448 100.7 448 95.1s-2.109-9.248-5.75-12.28l-96-80c-6.797-5.688-16.89-4.719-22.55 2.031c-5.656 6.781-4.734 16.88 2.047 22.53L387.8 80H176C78.95 80 0 158.1 0 255.1C0 264.8 7.156 272 16 272S32.01 264.8 32.01 256C32.01 176.6 96.59 112 176 112zM496 240c-8.844 0-16.01 7.156-16.01 16c0 79.41-64.59 144-143.1 144H124.2l62.05-51.72c6.781-5.656 7.703-15.75 2.047-22.53C182.7 319 172.6 318.1 165.8 323.7l-96 80C66.11 406.8 64 411.2 64 415.1s2.109 9.25 5.75 12.28l96 80C168.8 510.8 172.4 512 175.1 512c4.594 0 9.141-1.969 12.31-5.75c5.656-6.781 4.734-16.88-2.047-22.53L124.2 432H336c97.05 0 176-78.97 176-176C512 247.2 504.8 240 496 240z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsRepeat);
export default __webpack_public_path__ + "static/media/arrows-repeat.bf127cf832343db86691562d293a127e.svg";
export { ForwardRef as ReactComponent };